import { Config } from 'store/config';
import { UsdValues } from 'types/firebase';
import { Provider } from '@ethersproject/providers';
import { transformSubEvents } from 'helpers/transformSubEvents';
import { Crucible, ExtendedRewardProgram } from 'types';
import {
  getChristmasFlag,
  getCrucibleHistory,
  getCurrentRewardProgramsData,
  getEthBalance,
  getStakeData,
  getTimestamp
} from 'utils/crucibleNft';

export async function getCrucibleNftData(
  crucible: Crucible,
  chainId: number,
  config: Config,
  provider: Provider,
  usdValues: UsdValues,
  rewardPrograms: ExtendedRewardProgram[]
): Promise<any> {
  const { id, mintTimestamp } = crucible;
  const [timestamp, christmasFlag, ethBalance, stakeData] = await Promise.all([
    getTimestamp(chainId),
    getChristmasFlag(config, crucible, provider),
    getEthBalance(crucible, provider),
    getStakeData(config, crucible)
  ]);

  const currentRewardProgramsData = await getCurrentRewardProgramsData(
    stakeData,
    crucible,
    chainId,
    provider,
    rewardPrograms,
    usdValues,
    timestamp
  );

  const crucibleHistory = await getCrucibleHistory(
    rewardPrograms,
    currentRewardProgramsData.activeSubscriptionDurations,
    stakeData
  );

  const activeAludelSubs = currentRewardProgramsData.activeAludelSubs;
  const historicalAludelSubs = crucibleHistory.historicalAludelSubs;

  const aludelSubs = [
    ...activeAludelSubs.flat(),
    ...historicalAludelSubs.flat()
  ];

  const aludelSubsTier = transformSubEvents(aludelSubs);

  const data = {
    id,
    currentRewardPrograms: currentRewardProgramsData.currentSubscriptions,
    historicalRewardPrograms: crucibleHistory.historicalRewardPrograms,
    ethBalance,
    mistBalance: 0, // Hardcoded for now
    mintTimestamp,
    mintNumber: crucibleHistory.mintNumber,
    tokenUSDValues: usdValues,
    totalSubscribedValue: currentRewardProgramsData.totalSubscribedValue,
    aludelSubscriptions: aludelSubsTier,
    christmasFlag
  };

  // TODO: Remove any
  return data as any;
}
